import { Button, TextField, Box } from '@mui/material';
import React, { useEffect } from 'react';

export function QuantityInput({
    value,
    onChange,
    min = 1,
    max,
    disabled = false,
    onClickCapture,
    justifyContent = 'center',
    error = false,
    increment = 1,
    label = undefined,
    width = '60px'
}: QuantityInputProps) {

    const handleIncrement = (e: React.MouseEvent) => {
        e.stopPropagation();
        const currentValue = parseInt(value) || 0;
        if (!max || currentValue < max) {
            onChange((currentValue + increment).toString());
        }
    };

    const handleDecrement = (e: React.MouseEvent) => {
        e.stopPropagation();
        const currentValue = parseInt(value) || 0;
        if (currentValue > min) {
            onChange((currentValue - increment).toString());
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        const newValue = e.target.value;

        // Permite qualquer valor durante a digitação
        onChange(newValue);
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const numeroValue = parseInt(value);

        if (isNaN(numeroValue) || numeroValue < min || value === '') {
            onChange(min.toString());
            return;
        }

        if (max && numeroValue > max) {
            onChange(max.toString());
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'ArrowRight') {
            e.preventDefault();
            const currentValue = parseInt(value) || 0;
            if (!max || currentValue < max) {
                onChange((currentValue + increment).toString());
            }
        } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            const currentValue = parseInt(value) || 0;
            if (currentValue > min) {
                onChange((currentValue - increment).toString());
            }
        }
    };

    useEffect(() => {
        if (value === '') {
            onChange(min.toString());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent }}>
            <Button
                onClick={handleDecrement}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        e.stopPropagation();
                        const currentValue = parseInt(value) || 0;
                        if (currentValue > min) {
                            onChange((currentValue - increment).toString());
                        }
                    }
                }}
                sx={quantidadeButtonStyle}
                disabled={disabled || parseInt(value) <= min}
            >
                -
            </Button>
            <TextField
                {...{ error }}
                type="number"
                label={label}
                size="small"
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onBlur={handleBlur}
                onClick={(e) => e.stopPropagation()}
                onClickCapture={onClickCapture}
                disabled={disabled}
                sx={{ width: width, '& input': { textAlign: 'center' } }}
                slotProps={{
                    htmlInput: { min, max }
                }}
            />
            <Button
                onClick={handleIncrement}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        e.stopPropagation()
                        const currentValue = parseInt(value) || 0;
                        if (!max || currentValue < max) {
                            onChange((currentValue + increment).toString());
                        }
                    }
                }}
                sx={quantidadeButtonStyle}
                disabled={disabled}
            >
                +
            </Button>
        </Box>
    );
}

const quantidadeButtonStyle = {
    minWidth: '32px',
    padding: '4px',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    mx: 0.5
};

interface QuantityInputProps {
    value: string;
    label?: string;
    onChange: (value: string) => void;
    min?: number;
    max?: number;
    disabled?: boolean;
    onClickCapture?: (e: React.MouseEvent) => void;
    justifyContent?: 'flex-end' | 'flex-start' | 'center';
    error?: boolean;
    increment?: number;
    width?: string | number;
}